import { FloatingInformationService } from '../service/floating-information'

export let floatingInformationService: FloatingInformationService

export function floatingInformationInit() {
	const triggers = document.querySelectorAll('[data-fi]')

	if (!triggers) {
		return
	}

	const floatingInformationService = new FloatingInformationService()

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault()

			const title = trigger.getAttribute('data-fi-title')
			const content = trigger.getAttribute('data-fi-content')
			const link = trigger.getAttribute('data-fi-link')

			floatingInformationService.open({
				title,
				content,
				link,
				button: trigger as HTMLElement,
			})

			return
		})
	})
}
